import * as React from 'react';

import * as ReactDOM from 'react-dom';
import IntlProvider from 'react-intl/src/components/provider';

import { ResetPasswordPage } from '@ReactComponents/ResetPasswordPage/ResetPasswordPage';

import { AbacusEmbarkProvider } from '@Shared/AbacusEmbarkProvider';

// Set the public path for webpacked assets
// https://webpack.js.org/guides/public-path/
__webpack_public_path__ = window.webpack_public_path;
ReactDOM.render(
  <div>
    <AbacusEmbarkProvider>
      <IntlProvider locale="en-US">
        <ResetPasswordPage />
      </IntlProvider>
    </AbacusEmbarkProvider>
  </div>,
  document.querySelector('#app')
);
